enum StatusE {
  IDLE,
  LOADING,
  ERROR,
  CREATED,
}

export default StatusE
